import React from 'react';
import { LayoutDashboard, Table2 } from 'lucide-react';
import type { ViewMode } from './types';

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (v: ViewMode) => void;
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = function ({ value, onChange }) {
  return (
    <div className="flex bg-gray-100 rounded-xl p-1 gap-0.5">
      <button
        onClick={function () { onChange('graphical'); }}
        className={
          'flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all ' +
          (value === 'graphical' ? 'bg-white text-[#F36B21] shadow-sm' : 'text-gray-500 hover:text-gray-700')
        }
      >
        <LayoutDashboard className="w-4 h-4" />Graphical
      </button>
      <button
        onClick={function () { onChange('tabular'); }}
        className={
          'flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all ' +
          (value === 'tabular' ? 'bg-white text-[#F36B21] shadow-sm' : 'text-gray-500 hover:text-gray-700')
        }
      >
        <Table2 className="w-4 h-4" />Tabular
      </button>
    </div>
  );
};

export default ViewModeToggle;
